import React, { Component } from "react";
import Header from "../components/header.component";
import "../css/homepage.css";

import twitterIcon from "../images/web-icons/twitter-gray.svg";
import linkedInIcon from "../images/web-icons/linkedin-gray.svg";
import googlePlayIcon from "../images/web-icons/google-play-dark.svg";
import dateTimeHelper from "../helpers/date-time.helper";
import { Link } from "react-router-dom";
import reportVisitService from "../reporting-visit/report-visit.service";

export default class HomePage2 extends Component {
  componentDidMount() {
    document.title = "David Šimák | A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    return (
      <div>
        <Header showLogo={false} customColor="#424242" lightColor={true} />
        <div className="welcome_container">
          <div className="welcome_section_left">
            <div className="welcome_role">
              Self-taught Java/Kotlin developer
            </div>
            <label className="welcome_my_name welcome_my_name_bold">
              David
            </label>
            <label className="welcome_my_name">Šimák</label>

            <hr className="section-title-hr" />
            <div className="welcome_skills">
              Java, Kotlin, Android, Rest API, Spring Boot, Microservices,
              Docker, Kubernetes, PostgreSQL, SQLite, Debian, Fedora,
              JavaScript, ReactJS. Redis
            </div>

            <div className="welcome_years_of_experience">
              <label className="welcome_years_of_experience_number">
                {dateTimeHelper.calculateDurationYears(
                  new Date(2015, 6, 15),
                  new Date()
                )}
              </label>
              <label className="welcome_years_of_experience_text">
                Years of experience
              </label>
            </div>
          </div>

          <div className="welcome_section_right">
            <div className="welcome_about_me">
              <br />I am a self-taught Java/Kotlin developer from Zlín, Czech
              Republic, with a passion for developing innovative applications.
              My programming journey started in 2015 with Android development in{" "}
              <b>Java</b> and later I expanded my skills to web development
              using <b>ReactJS</b> and <b>Spring</b>, but I am mainly focused on{" "}
              <b>backend development.</b> I have also skills in technologies
              like <b>Kubernetes, Docker, PostgreSQL.</b> <br />
              Currently, I am focused on building innovative marketing tools and
              tools for effective brand management at{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.papirfly.com"
                className="text-bold-background"
              >
                Papirfly
              </a>{" "}
              and in my free time on developing my{" "}
              <Link to="/projects" className="text-bold-background">
                personal projects.
              </Link>
            </div>

            <div className="welcome_contacts">
              <div className="welcome_contact_row">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/david-simak/"
                  className="welcome_contact_row_link"
                >
                  <img
                    src={linkedInIcon}
                    className="welcome_contact_row_icon"
                  />
                </a>
                <a
                  className="welcome_contact_row_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://twitter.com/davidsimakdev"
                >
                  <img src={twitterIcon} className="welcome_contact_row_icon" />
                </a>
                <a
                  className="welcome_contact_row_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://play.google.com/store/apps/dev?id=8118818926414655679"
                >
                  <img
                    src={googlePlayIcon}
                    className="welcome_contact_row_icon"
                  />
                </a>
              </div>
              <div className="welcome_contact_row">
                <a
                  className="welcome_contact_row_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="mailto://david@davidsimak.dev"
                >
                  david@davidsimak.dev
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
